module.exports = "<div id=\"four-oh-four\">\n  <div class=\"col-sm-6 col-sm-offset-3\">\n    <h2 class=\"center\">404 Page Not Found</h2>\n    <h3 class=\"center\">\n      Oops, we can't find the page you're looking for.\n    </h3>\n    <p class=\"center\">\n      <a href=\"#\" ui-sref=\"login\" class=\"btn btn-primary\">\n        Back to login\n      </a>\n    </p>\n  </div>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/components/notFound/notFound.html
// module id = 1167
// module chunks = 0